const state = {
  login: [ {auth: '', userdata: []} ]
}
const getters = {
  GET_AUTH (state) {
    return state.login[0].auth
  },
  GET_USERDATA (state) {
    return state.login[0].userdata
  }

}
const mutations = {
  SET_AUTH (state, auth) {
    if (auth) {
      state.login[0].auth = auth
    }
    console.log(state.login[0].auth)
  },
  SET_USERDATA (state, userdata) {
    if (userdata) {
      state.login[0].userdata = userdata
    }
    console.dir(state.login[0].userdata)
  }
}
const actions = {
  SAVE_LOGIN_AUTH ({commit}, auth) {
    commit('SET_AUTH', auth)
  },
  SAVE_LOGIN_USERDATA ({commit}, userdata) {
    commit('SET_USERDATA', userdata)
  },
  SAVE_LOGOUT_AUTH ({commit}) {
    commit('SET_AUTH', null)
    commit('SET_USERDATA', null)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js